export default "__VITE_ASSET__DKx01bCn__"